import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconMegaphoneSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="megaphone solid">
            <g clipPath="url(#clip0_8888_1461)">
                <path
                    d="M8.74551 6.30381C8.30619 6.41942 8 6.81662 8 7.27089V16.7291C8 17.1834 8.30619 17.5806 8.74551 17.6962L17.133 19.9034C17.3694 19.9656 17.5749 20.1123 17.7105 20.3158L19.2031 22.5547C19.3886 22.8329 19.7008 23 20.0352 23H23C23.5523 23 24 22.5523 24 22V2C24 1.44772 23.5523 1 23 1H20.0352C19.7008 1 19.3886 1.1671 19.2031 1.4453L17.7105 3.68421C17.5749 3.88766 17.3694 4.03436 17.133 4.09659L8.74551 6.30381Z"
                    fill={props.fill || 'currentColor'}
                />
                <path
                    d="M0 9C0 7.89543 0.895431 7 2 7H6V17H2C0.89543 17 0 16.1046 0 15V9Z"
                    fill={props.fill || 'currentColor'}
                />
                <path
                    d="M3.00004 19.0001H6.00004L8.00004 19.5001V21.0001C8.00004 22.657 6.65689 24.0001 5.00004 24.0001H4.00004C3.44775 24.0001 3.00004 23.5524 3.00004 23.0001V19.0001Z"
                    fill={props.fill || 'currentColor'}
                />
            </g>
            <defs>
                <clipPath id="clip0_8888_1461">
                    <rect
                        width="24"
                        height="24"
                        fill={props.fill || 'currentColor'}
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
